export enum ConfirmDialogTitles {
  Approve = "Confirm Approval",
  Delete = "Confirm Delete",
  Empty = "Empty Selection",
  Invalid = "Invalid Selection",
  Update = "Update Document",
}
